import Seo, { SITE_NAME, SITE_ORIGIN } from '@/components/feature/Seo';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import LatestFeed from '@/pages/home/components/LatestFeed';
import EditorsPick from '@/pages/home/components/EditorsPick';
import FaqSection from '@/pages/home/components/FaqSection';
import { faqs } from '@/mocks/faqs';

const schema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_ORIGIN,
    description: '中文娱乐爆料资讯门户，每日整理明星八卦、网红动态、素人投稿与圈内观察。',
    email: 'contact@18baoliao.com',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_ORIGIN,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_ORIGIN}/category/all?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="18爆料网 | 今日爆料实时更新 · 最新猛料每日追更"
        description="18爆料网今日爆料实时更新，聚合明星八卦、网红翻车、素人投稿与圈内内幕。想看最新猛料和热门爆料，这里每天都有新鲜内容，一次看个够。"
        keywords="18爆料网,18爆料网今日爆料,18爆料网最新猛料,18爆料网热门爆料,18爆料网今日更新"
        path="/"
        image="https://readdy.ai/api/search-image?query=abstract%20dramatic%20entertainment%20news%20hero%20scene%20with%20warm%20crimson%20spotlights%20and%20golden%20confetti%20bokeh%2C%20cinematic%20magazine%20cover%20style%2C%20dark%20elegant%20background%20contrasting%20bright%20light%2C%20no%20text%2C%20no%20identifiable%20faces%2C%20high%20detail%2C%20luminous%20atmosphere&width=1200&height=800&seq=hero-18baoliao-main&orientation=landscape"
        schema={schema}
      />
      <HeroSection />
      <CategoryGrid />
      <LatestFeed />
      <EditorsPick />
      <FaqSection />
    </>
  );
}